import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import ServiceAreas from "@/components/sections/ServiceAreas";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import MobileStickyCTA from "@/components/sections/MobileStickyCTA";
import MoldClickFx from "@/components/effects/MoldClickFx";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="relative min-h-screen bg-white dark:bg-[#0A2513] text-[#0E2A17] dark:text-[#F2FAF4] transition-colors duration-500"
    >
      <Header />
      <Hero />
      <Services />
      <Process />
      <ServiceAreas />
      <FAQ />
      <Contact />
      <Footer />
      <MobileStickyCTA />
      <MoldClickFx />
    </main>
  );
}
